module.exports = __webpack_public_path__ + "img/profile_man_p.5e6a4203.png";